/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Cta_ReferenceInputs */

const en_tut_cta_reference = /** @type {(inputs: Tut_Cta_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to the quick reference`)
};

const id_tut_cta_reference = /** @type {(inputs: Tut_Cta_ReferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke referensi cepat`)
};

/**
* | output |
* | --- |
* | "Jump to the quick reference" |
*
* @param {Tut_Cta_ReferenceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_cta_reference = /** @type {((inputs?: Tut_Cta_ReferenceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Cta_ReferenceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_cta_reference(inputs)
	return en_tut_cta_reference(inputs)
});